import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    selectorButton: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    header: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    modalContent: {
        width: "100%",
        maxWidth: 500
    },
    searchInput: {
    },
    listContent: {
    },
    container: {
    },
    orgItem: {
    }
});
export default stylesheet;
